export default __webpack_public_path__ + "static/socialcard-57c732c99a77154c94789f6730d02d8e.jpg";